import Breadcrumb from "@/components/Breadcrumb";
import ContentTitle from "@/components/ContenTitle";
import ProfileForm from "@/features/partners/components/ProfileForm";
import TaskForm from "@/features/partners/components/TaskForm";
import ProjectsForm from "@/features/partners/components/ProjectsForm";
import { useState } from "react";
import { useQuery } from "react-query";
import { fetchAllPartners } from "@/api/partners";
import { useParams } from "react-router-dom";
import LoadingSpinner from "@/components/UI/LoadingSpinner";

const pages = [{ name: "Partners", href: "/partners", current: false }];

const tabs = [
  { name: "Profile", href: "#", current: true },
  { name: "Tasks", href: "#", current: false },
];

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

const PartnerDetailPage = () => {
  const [selectedTab, setSelectedTab] = useState(tabs[0].name);

  const { id } = useParams<{ id: string }>();

  const { data, isLoading } = useQuery("fetchPartnerForDetail", () => fetchAllPartners(id), {
    enabled: !!id,
  });

  console.log("data", data);

  return (
    <div>
      <ContentTitle title="Partner Detail" />
      <Breadcrumb pages={pages} />

      {isLoading ? (
        <LoadingSpinner size="w-6 h-6 mt-8" />
      ) : (
        <>
          <div className="mt-4 flex gap-8">
            <div className="">
              <div className="text-lg font-semibold text-gray-900">
                {data?.first_name} {data?.last_name}
              </div>
              <img
                className="w-48 h-40 mt-5 object-cover rounded-full border"
                src={data?.avatar ?? "/assets/img/avatar.png"}
                alt="partner"
              />
            </div>
            <div className="w-full">
              <div className="font-medium text-gray-900 text-lg">Detail</div>
              <div>
                <div className="sm:hidden">
                  <label htmlFor="tabs" className="sr-only">
                    Select a tab
                  </label>
                  {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
                  <select
                    id="tabs"
                    name="tabs"
                    value={selectedTab}
                    onChange={(e) => setSelectedTab(e.target.value)}
                    className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm">
                    {tabs.map((tab) => (
                      <option value={tab.name} key={tab.name}>
                        {tab.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="hidden sm:block">
                  <div className="border-b border-gray-200">
                    <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                      {tabs.map((tab) => (
                        <div
                          key={tab.name}
                          onClick={() => setSelectedTab(tab.name)}
                          className={classNames(
                            selectedTab === tab.name
                              ? "border-indigo-500 text-indigo-600"
                              : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700",
                            "whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium"
                          )}>
                          {tab.name}
                        </div>
                      ))}
                    </nav>
                  </div>
                </div>
              </div>

              {selectedTab === "Profile" && <ProfileForm data={data} />}
              {selectedTab === "Tasks" && <TaskForm />}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PartnerDetailPage;
